import { Trans, useLingui } from "@lingui/react/macro";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "react-oidc-context";
import { useEffect } from "react";
import { FilledButton } from "@medoma/components/Button/Button";
import { Heading } from "@medoma/components/Heading/Heading";
import { Text } from "@medoma/components/Text/Text";
import styles from "./requireAuth.module.scss";

const DevicePairing = () => {
  const auth = useAuth();
  const { isLoading } = auth;
  const { t } = useLingui();
  return (
    <div className={styles.devicePairing}>
      <Heading level="h1">
        <Trans>Koppla patient</Trans>
      </Heading>
      <Text element="p" size="small">
        <Trans>
          Koppla patienten via utrustningssidan och klicka sedan på knappen
          nedan för att bekräfta kopplingen.
        </Trans>
      </Text>
      <FilledButton disabled={isLoading} onClick={() => auth.signinSilent()}>
        {isLoading ? t`Bekräftar koppling...` : t`Bekräfta koppling`}
      </FilledButton>
    </div>
  );
};

const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuth();
  const { isAuthenticated, events, user } = auth;
  const location = useLocation();

  useEffect(() => {
    return events.addAccessTokenExpired(() =>
      auth.signinRedirect({
        state: window.location.pathname,
        acr_values: "mfa",
      }),
    );
  }, [auth, events]);

  const signedInAsDeviceOnly =
    isAuthenticated &&
    user?.profile.user_type === "device" &&
    user?.profile.role !== "Patient";

  if (signedInAsDeviceOnly) {
    return <DevicePairing />;
  }

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default RequireAuth;
